module.exports = "/hub/_next/static/assets/12d3da93f4d7ad2f918a6452a9618ee6.svg";